<input type="text" class="app-input" 
[value]="value"
[placeholder]="placeholder || ''"
[attr.disabled]="isDisabled ? true : null"
(keyup)="onKeyup($event.target.value)"
(blur)="onBlur()"
>
<!-- <mat-label>test
    <span class="form-field__req">*</span>
</mat-label>
<input matInput class="" 
[value]="value"
[placeholder]="placeholder || ''"
[attr.disabled]="isDisabled ? true : null"
(keyup)="onKeyup($event.target.value)"
(blur)="onBlur()"
>
<mat-icon matPrefix>
    <img src="../../../../../assets/images/password.png" class="input-img">
</mat-icon> -->
    